import { AfterViewInit, Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";
import { Invoice } from "src/app/models/invoice-model";
import { AuthService } from "src/app/services/auth/auth.service";
import { DateFormatterService } from "src/app/services/date-formatter/date-formatter.service";
import { Webflow } from "src/app/utils/webflow";
import { StripeService } from "src/app/services/stripe/stripe.service";

@Component({
  selector: "app-mes-factures",
  templateUrl: "./mes-factures.component.html",
  styleUrls: ["./mes-factures.component.scss"],
})
export class MesFacturesComponent implements OnInit, AfterViewInit {
  loading: boolean = true;
  invoices: Array<Invoice> = [];
  has_more: boolean = false;

  start_at: string = "";

  nbr_items_in_page: number = 8;

  current_page: number = 1;

  constructor(
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private stripeService: StripeService,
    private spinner: NgxSpinnerService,
    public router: Router,
    private dateFormatterService: DateFormatterService
  ) {}

  ngOnInit(): void {
    this.get_my_invoinces(true);
  }

  ngAfterViewInit(): void {
    Webflow.setIFrameHeight();
  }

  get_my_invoinces(scrolToTop: boolean) {
    this.spinner.show();
    this.activatedRoute.queryParams.subscribe((params) => {
      let more_params = [
        { key: "limit", value: this.nbr_items_in_page.toString() },
      ];

      if (params.subscription) {
        more_params.push({ key: "subscription", value: params.subscription });
      }

      if (this.start_at != "") {
        more_params.push({ key: "start_at", value: this.start_at });
      }

      this.stripeService
        .mes_factures(more_params)
        .subscribe(
          (res) => {
            this.has_more = res.has_more;

            res.data.forEach((item: any) => {
              this.invoices.push(new Invoice(Invoice.attributeToJson(item)));
            });
            setTimeout(() => {
              Webflow.setIFrameHeight(scrolToTop,this.current_page*40);
            }, 500);
          },
          (err) => {
            this.current_page = 1;
            this.invoices = [];
            Webflow.setIFrameHeight();
            Swal.fire({
              title: "Érreur",
              text: "Une érreur est survenue",
              icon: "error",
              position: "top",
            });
          }
        )
        .add(() => {
          this.spinner.hide();
          this.loading = false;
        });
    });
  }

  get_more() {
    this.start_at = this.invoices[this.invoices.length - 1].id;
    this.current_page++;
    this.get_my_invoinces(false);
  }

  timestamp_to_date_format(timestamp: any) {
    let date = new Date(timestamp * 1000);
    return this.dateFormatterService.showDateHour(date);
  }
}
